import { useCart } from "../../contexts/Cart/CartContext";
import { CiShoppingCart } from "react-icons/ci";

const FloatingCartButton = () => {
  const { toggleDrawer } = useCart();

  return (
    <button
      className="participant-shop-floating-button"
      onClick={toggleDrawer}
      aria-label="Open shopping cart"
    >
      <CiShoppingCart fontSize={50} />
    </button>
  );
};

export default FloatingCartButton;
